import { RelationshipValues } from '../relatedOrganisations/RelatedOrganisations.types'

import { Validation } from '@percent/admin-dashboard/api/types'
import { validationOrganisationHasRelationships } from './validationOrganisationHasRelationships'

export const validationOrganisationIsParent = (validation?: Validation): boolean =>
  validationOrganisationHasRelationships(validation) &&
  !!validation?.organisation?.relationships?.find(({ relationship }) => relationship === RelationshipValues.PARENT)
